import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { Asignacion } from '../shared/models/asignacion';
import { Solicitud } from '../shared/models/solicitud';
import { TipoAsignacion } from '../shared/models/tipo-asignacion';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { TipoAsignacionService } from '../shared/services/tipo-asignacion.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { environment } from '../../environments/environment';
import { AsignacionDispositivoDto } from '../shared/models/asignacion-dispositivos';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
@Component({
  selector: 'app-solicitar-dir-vlan',
  templateUrl: './solicitar-dir-vlan.component.html',
  styleUrls: ['./solicitar-dir-vlan.component.css']
})
export class SolicitarDirVlanComponent implements OnInit {


  modalAgregarFormGoup = this.formBuilder.group({
    urlControl: [''],
    servidorControl: ['', Validators.required],
    servicioControl: ['', Validators.required],
    plataformaControl: ['', Validators.required],
    rolControl: ['', Validators.required],
    controlObeservaciones: new FormControl(),
    controlDns: new FormControl(),
    checkDns: new FormControl()
  });

  private codigoListaAmbientes = environment.listaCodigoAmbientes;
  private codigoListaUrl = environment.listaCodigoUrl;
  private codigoListaServidor = environment.listaCodigoServidor;
  private codigoListaServicio = environment.listaCodigoServicio;
  private codigoListaPlataforma = environment.listaCodigoPlataforma;
  private codigoListaRol = environment.listaCodigoRol;
  private urlSubject = new Subject<string>();
  private servidorSubject = new Subject<string>();

  companias: Compania[];
  ciudades: Ciudad[];
  sedes: Sede[];
  vlans: Vlan[];
  vlansParaAgregar: Vlan[] = new Array<Vlan>();
  resultadoAsignacion: Asignacion[] = new Array<Asignacion>();
  idCompaniaSeleccionada = -1;
  companiaSeleccionada: Compania = new Compania();
  idCiudadSeleccionada = -1;
  idSedeSeleccionada = -1;
  idAmbienteSelecccionado = -1;
  idVlanSeleccionado = -1;
  ambientes: ListaItem[];
  tiposAsignacion: TipoAsignacion[];
  tiposElementos: String[];
  cantidadElementos: number[];
  cantidadElementosEleccion: number[] = new Array();
  idTipoAsignacionSeleccionado: number;
  listaDispositivosAsignar: AsignacionDispositivoDto[];
  asignacionDispositivoNuevo: AsignacionDispositivoDto;
  vlanAsignacion: Vlan;
  tipoasignacionSeleccionado: TipoAsignacion;
  urls: ListaItem[];
  urlsFiltradas: ListaItem[];
  urlSeleccionado: ListaItem;
  servidores: ListaItem[];
  servidoresFiltrados: ListaItem[];
  servidorSeleccionado: ListaItem;
  servicios: ListaItem[];
  serviciosFiltrados: ListaItem[];
  servicioSeleccionado: ListaItem;
  plataformas: ListaItem[];
  plataformaFiltradas: ListaItem[];
  plataformaSeleccionado: ListaItem;
  roles: ListaItem[];
  rolesFiltrados: ListaItem[];
  rolSeleccionado: ListaItem;
  observaciones: string;
  dns = '';
  asignaciones: Asignacion[] = new Array<Asignacion>();
  agregarActivo = false;
  agregarDns = false;
  modalRef: NgbModalRef;
  solicitudSeleccionada: Solicitud;
  solicitudes: Solicitud[] = new Array<Solicitud>();
  indicadorEdicion = false;
  indexEditar: number;
  lblBotonAgregar: string;
  asignacionesGeneradas: Asignacion[] = new Array<Asignacion>();
  rangoVlan = '';
  cantidadDispositivos: number = null;
  tipoDispositivo: string = null;
  error;
  estadoAgregarDispositivo: boolean = false;
  estadoTipoVlan: boolean = null;


  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private tipoAsignacionService: TipoAsignacionService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.listarCompanias();
    this.listarTiposAsignacion();
    this.cargarListasDialogo();
    this.tiposElementos = ["ROUTER", 'SWITCH', 'WLC', 'AP', 'UPS', 'ATS', 'OTROS'];
    this.cantidadElementos = [3, 50, 1, 50, 31, 31, 50]
    this.listaDispositivosAsignar = new Array();
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public listarCiudadaesPorCompania(): void {
    this.seleccionarCompania();
    this.idCiudadSeleccionada = -1;
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.ciudades = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.ciudadService.ciudadesPorIdCompania(this.idCompaniaSeleccionada).subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => this.sedes = resultado
    );
  }

  public listarAmbientes(): void {
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.ambientes = null;
    this.vlans = null;
    this.agregarActivo = false;    
    this.idAmbienteSelecccionado = 20;
    this.listarVlanPorSedeAmbienteCompania();
  }

  public listarVlanPorSedeAmbienteCompania(): void {
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.vlans = null;
    this.agregarActivo = false;
    this.vlanService.vlansPorSedeAmbienteCompania(this.idSedeSeleccionada,
      this.idAmbienteSelecccionado, this.idCompaniaSeleccionada, true).subscribe(
        resultado => { 
          this.vlans = resultado 
          this.vlans = this.vlans.filter(
            vlanSede => (!vlanSede.nombreVlan.includes('LOOPBACK')));
        }
      );
  }

  public listarTiposAsignacion(): void {
    this.idTipoAsignacionSeleccionado = -1;
    this.tiposAsignacion = null;
    this.tipoasignacionSeleccionado = null;
    this.tipoAsignacionService.listarTiposAsignacion().subscribe(
      resultado => this.tiposAsignacion = resultado
    );
  }

  public cambioTipoAsignacion(): void {
    ["ROUTER", 'SWITCH', 'WLC', 'AP', 'UPS', 'ATS', 'OTROS']
    this.agregarActivo = true;
    switch (this.tipoDispositivo) {
      case "ROUTER":
        this.cantidadElementosEleccion = Array.from(Array(this.cantidadElementos[0]), (e, i) => i + 1)
        break;
      case "SWITCH":
        this.cantidadElementosEleccion = Array.from(Array(this.cantidadElementos[1]), (e, i) => i + 1)

        break;
      case "WLC":
        this.cantidadElementosEleccion = Array.from(Array(this.cantidadElementos[2]), (e, i) => i + 1)

        break;
      case "AP":
        this.cantidadElementosEleccion = Array.from(Array(this.cantidadElementos[3]), (e, i) => i + 1)

        break;
      case "UPS":
        this.cantidadElementosEleccion = Array.from(Array(this.cantidadElementos[4]), (e, i) => i + 1)

        break;
      case "ATS":
        this.cantidadElementosEleccion = Array.from(Array(this.cantidadElementos[5]), (e, i) => i + 1)

        break;
      case "OTROS":
        this.cantidadElementosEleccion = Array.from(Array(this.cantidadElementos[6]), (e, i) => i + 1)

        break;
      default:
        this.cantidadElementosEleccion = new Array();
        break;
    }

  }

  public limpiarDialogo(): void {
    this.urlSeleccionado = null;
    this.servidorSeleccionado = null;
    this.servicioSeleccionado = null;
    this.plataformaSeleccionado = null;
    this.rolSeleccionado = null;
    this.solicitudSeleccionada = new Solicitud();
    this.solicitudSeleccionada.tipoAsignacion = new TipoAsignacion();
    this.agregarDns = false;
    this.dns = '';
    this.observaciones = '';
  }

  public mostrarModalSolicitud(servidorModal): void {
    this.cargarListasDialogo();
    this.limpiarDialogo();
    this.modalAgregarFormGoup.reset();
    if (!this.indicadorEdicion) {
      if (this.idTipoAsignacionSeleccionado != -1 && this.idTipoAsignacionSeleccionado != null) {
        this.solicitudSeleccionada.tipoAsignacion = this.tipoasignacionSeleccionado;
        this.lblBotonAgregar = 'Agregar';
      } else {
        return;
      }
    } else {
      this.lblBotonAgregar = 'Editar';
    }
    if (this.solicitudSeleccionada.tipoAsignacion.tipoBase == 'U') {
      this.modalAgregarFormGoup.controls['urlControl'].setValidators(Validators.required);
    } else {
      this.modalAgregarFormGoup.controls['urlControl'].clearValidators();
    }
    this.modalRef = this.modalService.open(servidorModal, { size: 'lg' });

  }


  public ocultarModalSolicitud(): void {
    this.indicadorEdicion = false;
    this.modalRef.close();
  }

  public ListarUrl(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaUrl).subscribe(
      resultado => this.urls = resultado
    );
  }

  public ListarServidor(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaServidor).subscribe(
      resultado => this.servidores = resultado
    );
  }

  public ListarServicio(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaServicio).subscribe(
      resultado => this.servicios = resultado
    );
  }

  public ListarPlataformas(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaPlataforma).subscribe(
      resultado => this.plataformas = resultado
    );
  }

  public ListarRoles(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaRol).subscribe(
      resultado => this.roles = resultado
    );
  }

  filterRol(event) {
    this.rolesFiltrados = [];
    for (let i = 0; i < this.roles.length; i++) {
      const rol = this.roles[i];
      if (rol.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.rolesFiltrados.push(rol);
      }
    }
    if (this.rolesFiltrados.length == 1 &&
      event.query.toUpperCase() == this.rolesFiltrados[0].valorItem) {
      this.rolSeleccionado = this.rolesFiltrados[0];
    } else {
      const rolNuevo: ListaItem = new ListaItem();
      rolNuevo.codigoItem = (this.roles.length + 1).toString();
      rolNuevo.indicadorHabilitado = true;
      rolNuevo.lista = this.roles[0].lista;
      rolNuevo.valorItem = event.query;
      rolNuevo.idListaItem = null;
      this.rolSeleccionado = rolNuevo;
    }
  }

  filterPlataforma(event) {
    this.plataformaFiltradas = [];
    for (let i = 0; i < this.plataformas.length; i++) {
      const plataforma = this.plataformas[i];
      if (plataforma.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.plataformaFiltradas.push(plataforma);
      }
    }
    if (this.plataformaFiltradas.length == 1 &&
      event.query.toUpperCase() == this.plataformaFiltradas[0].valorItem) {
      this.plataformaSeleccionado = this.plataformaFiltradas[0];
    } else {
      const itemNuevo: ListaItem = new ListaItem();
      itemNuevo.codigoItem = (this.plataformas.length + 1).toString();
      itemNuevo.indicadorHabilitado = true;
      itemNuevo.lista = this.plataformas[0].lista;
      itemNuevo.valorItem = event.query;
      itemNuevo.idListaItem = null;
      this.plataformaSeleccionado = itemNuevo;
    }
  }

  filterServicio(event) {
    this.serviciosFiltrados = [];
    for (let i = 0; i < this.servicios.length; i++) {
      const servicio = this.servicios[i];
      if (servicio.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.serviciosFiltrados.push(servicio);
      }
    }
    if (this.serviciosFiltrados.length == 1 &&
      event.query.toUpperCase() == this.serviciosFiltrados[0].valorItem) {
      this.servicioSeleccionado = this.serviciosFiltrados[0];
    } else {
      const itemNuevo: ListaItem = new ListaItem();
      itemNuevo.codigoItem = (this.servicios.length + 1).toString();
      itemNuevo.indicadorHabilitado = true;
      itemNuevo.lista = this.servicios[0].lista;
      itemNuevo.valorItem = event.query;
      itemNuevo.idListaItem = null;
      this.servicioSeleccionado = itemNuevo;
    }
  }

  filterServidor(event) {
    this.servidoresFiltrados = [];
    for (let i = 0; i < this.servidores.length; i++) {
      const servidor = this.servidores[i];
      if (servidor.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.servidoresFiltrados.push(servidor);
      }
    }
    if (this.servidoresFiltrados.length == 1 &&
      event.query.toUpperCase() == this.servidoresFiltrados[0].valorItem) {
      this.servidorSeleccionado = this.servidoresFiltrados[0];
    } else {
      const itemNuevo: ListaItem = new ListaItem();
      itemNuevo.codigoItem = (this.servidores.length + 1).toString();
      itemNuevo.indicadorHabilitado = true;
      itemNuevo.lista = this.servidores[0].lista;
      itemNuevo.valorItem = event.query;
      itemNuevo.valorItem = itemNuevo.valorItem.replace(new RegExp(' ', 'g'), '').trim();
      itemNuevo.idListaItem = null;
      this.servidorSeleccionado = itemNuevo;
    }
  }

  filterUrl(event) {
    this.urlsFiltradas = [];
    for (let i = 0; i < this.urls.length; i++) {
      const url = this.urls[i];
      if (url.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.urlsFiltradas.push(url);
      }
    }
    if (this.urlsFiltradas.length == 1 &&
      event.query.toUpperCase() == this.urlsFiltradas[0].valorItem) {
      this.urlSeleccionado = this.urlsFiltradas[0];
    } else {
      const itemNuevo: ListaItem = new ListaItem();
      itemNuevo.codigoItem = (this.urls.length + 1).toString();
      itemNuevo.indicadorHabilitado = true;
      itemNuevo.lista = this.urls[0].lista;
      itemNuevo.valorItem = event.query;
      itemNuevo.valorItem = itemNuevo.valorItem.replace(new RegExp(' ', 'g'), '').trim();
      itemNuevo.idListaItem = null;
      this.urlSeleccionado = itemNuevo;
    }

  }

  settearAsignacion(): Asignacion {
    const asignacion: Asignacion = new Asignacion();
    asignacion.observaciones = this.observaciones == null ? this.observaciones : this.observaciones.toUpperCase();
    asignacion.compania = this.companiaSeleccionada;
    asignacion.configuracionDNS = this.dns == null ? this.dns : this.dns.toUpperCase();
    asignacion.funcion = this.rolSeleccionado;
    asignacion.nombreServidor = this.servidorSeleccionado;
    asignacion.indicadorDns = this.agregarDns;
    if (this.solicitudSeleccionada.tipoAsignacion.tipoBase == 'U') {
      asignacion.nombreURL = this.urlSeleccionado;
    } else {
      asignacion.nombreURL = new ListaItem();
    }
    asignacion.plataforma = this.plataformaSeleccionado;
    asignacion.servicioITNegocio = this.servicioSeleccionado;
    asignacion.tipoAsignacion = this.solicitudSeleccionada.tipoAsignacion;

    return asignacion;
  }

  agregarSolicitud(): void {
    const solicitud: Solicitud = new Solicitud();
    solicitud.asignacion = new Asignacion();
    if (this.indicadorEdicion) {
      this.guardarCambiosSolicitud();
    } else {
      solicitud.asignacion = this.settearAsignacion();
      solicitud.idVlanSeleccionada = this.idVlanSeleccionado;
      solicitud.tipoAsignacion = this.tipoasignacionSeleccionado;
      this.solicitudes.push(solicitud);
      this.verificarListaItem(this.solicitudes.length - 1);
    }
    this.ocultarModalSolicitud();
  }

  borrarDispositivo(dispositivo: AsignacionDispositivoDto): void {
    const index: number = this.listaDispositivosAsignar.indexOf(dispositivo);
    if (index != null && index >= 0) {
      this.listaDispositivosAsignar.splice(index, 1);
      swal("Se elimino correctamente el dispositivo", "", "success")
    }
  }
  borrarVlan(vlan: Vlan): void {
    const index: number = this.vlansParaAgregar.indexOf(vlan);
    if (index != null && index >= 0) {
      this.vlansParaAgregar.splice(index, 1);
      swal("Se elimino correctamente el dispositivo", "", "success")
    }
  }

  editarSolicitud(solicitud: Solicitud, modal) {
    this.indicadorEdicion = true;
    this.mostrarModalSolicitud(modal);
    this.indexEditar = this.solicitudes.indexOf(solicitud);
    this.urlSeleccionado = solicitud.asignacion.nombreURL;
    this.servidorSeleccionado = solicitud.asignacion.nombreServidor;
    this.servicioSeleccionado = solicitud.asignacion.servicioITNegocio;
    this.plataformaSeleccionado = solicitud.asignacion.plataforma;
    this.rolSeleccionado = solicitud.asignacion.funcion;
    this.dns = solicitud.asignacion.configuracionDNS;
    this.observaciones = solicitud.asignacion.observaciones;
    this.solicitudSeleccionada.tipoAsignacion = solicitud.tipoAsignacion;
    this.solicitudSeleccionada.idVlanSeleccionada = solicitud.idVlanSeleccionada;
    this.agregarDns = solicitud.asignacion.indicadorDns;
  }

  guardarCambiosSolicitud(): void {
    this.solicitudes[this.indexEditar].asignacion = this.settearAsignacion();
    this.verificarListaItem(this.indexEditar);
  }

  asignarDirecciones(modalResultado, cargandoModal): void {
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    this.administradorIpService.guardarAsignaciones(this.solicitudes).subscribe(
      resultado => {
        this.asignacionesGeneradas = resultado;
        this.modalRef.close();
        this.modalRef = this.modalService.open(modalResultado, { backdrop: 'static', keyboard: false, size: 'lg' });
      },
      error => {
        this.error = error;
        this.modalRef.close();
      }
    );
  }

  ocultarModalResultado() {
    this.solicitudes = new Array<Solicitud>();
    this.idCompaniaSeleccionada = -1;
    this.companiaSeleccionada = new Compania();
    this.idCiudadSeleccionada = -1;
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.rangoVlan = '';
    this.idTipoAsignacionSeleccionado = -1;
    this.tipoasignacionSeleccionado = null;
    this.modalRef.close();
  }

  verificarListaItem(index: number): void {
    if (this.solicitudes[index].tipoAsignacion.tipoBase == 'U') {
      if (this.solicitudes[index].asignacion.nombreURL.idListaItem == null) {
        this.guardarListas(this.solicitudes[index].asignacion.nombreURL, index);
      }
    }

    if (this.solicitudes[index].asignacion.nombreServidor.idListaItem == null) {
      this.guardarListas(this.solicitudes[index].asignacion.nombreServidor, index);
    }

    if (this.solicitudes[index].asignacion.servicioITNegocio.idListaItem == null) {
      this.guardarListas(this.solicitudes[index].asignacion.servicioITNegocio, index);
    }

    if (this.solicitudes[index].asignacion.plataforma.idListaItem == null) {
      this.guardarListas(this.solicitudes[index].asignacion.plataforma, index);
    }

    if (this.solicitudes[index].asignacion.funcion.idListaItem == null) {
      this.guardarListas(this.solicitudes[index].asignacion.funcion, index);
    }

  }

  public async guardarListas(item: ListaItem, index: number): Promise<void> {
    const listaItem: ListaItem = await this.listaItemService.guardarListaAsync(item);
    if (item.lista.codigoLista == this.codigoListaServidor) {
      this.solicitudes[index].asignacion.nombreServidor = listaItem;
    }
    if (item.lista.codigoLista == this.codigoListaUrl) {
      this.solicitudes[index].asignacion.nombreURL = listaItem;
    }
    if (item.lista.codigoLista == this.codigoListaServicio) {
      this.solicitudes[index].asignacion.servicioITNegocio = listaItem;
    }
    if (item.lista.codigoLista == this.codigoListaPlataforma) {
      this.solicitudes[index].asignacion.plataforma = listaItem;
    }
    if (item.lista.codigoLista == this.codigoListaRol) {
      this.solicitudes[index].asignacion.funcion = listaItem;
    }
  }

  cargarListasDialogo() {
    this.ListarUrl();
    this.ListarServidor();
    this.ListarServicio();
    this.ListarPlataformas();
    this.ListarRoles();
  }

  mostrarRangoVlan() {
    for (const vlan of this.vlans) {
      if (this.idVlanSeleccionado != -1) {
        if (vlan.idVlan == this.idVlanSeleccionado) {
          this.rangoVlan = vlan.ipInicialRango + ' - ' + vlan.ipFinalRango;
          this.estadoTipoVlan = false
          if (vlan.nombreVlan.toUpperCase().includes('TELCO')) {
            this.estadoTipoVlan = true;
          }
          else {
            this.listaDispositivosAsignar = new Array<AsignacionDispositivoDto>();
          }
          break;
        }
      } else {
        this.rangoVlan = '';
      }
    }
  }
  AgregarDispositivo() {

    this.estadoAgregarDispositivo = true;
  }

  validarIngresoDispositivos() {

    this.asignacionDispositivoNuevo = new AsignacionDispositivoDto();
    this.asignacionDispositivoNuevo = this.listaDispositivosAsignar.filter(x => x.nombre == this.tipoDispositivo)[0];
    if (this.asignacionDispositivoNuevo === undefined) {

      this.asignacionDispositivoNuevo = new AsignacionDispositivoDto();
      this.asignacionDispositivoNuevo.nombre = this.tipoDispositivo;
      this.asignacionDispositivoNuevo.cantidad = this.cantidadDispositivos;
      this.listaDispositivosAsignar.push(this.asignacionDispositivoNuevo);
      swal("Se agrego el dispositivo", "", "success")
    } else {
      swal("Se presento un error", "El dato ya existe en la lista por favor eliminelo para agregarlo nuevamente", "error")
    }

  }

  asignarDireccionamiento() {
    swal({
      title: "Procesando ",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)

    this.administradorIpService.asignarDispositivoVlan(this.vlansParaAgregar).subscribe(
      resultado => {
        this.resultadoAsignacion = resultado;
        if (this.resultadoAsignacion.length > 0) {
          let resultadoFinal: string = this.extraerResultado(resultado);
          swal("Se asocio correctamente", "Los rangos creados fueron los siguientes : \n" + resultadoFinal, "success").then(function () {
            // Redirect the user
            window.location.href = "/#/solicitar-ip";
          });
        }
        else {
          swal("Se presento un error al tratar de encontrar una ip para asignar", "", "error").then(function () {
            // Redirect the user
            window.location.reload();
          })
        }
      }, error => {
        swal("Se presento un error", "", "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );
  }
  extraerResultado(resultado: Asignacion[]): string {
    let resultadoUnion = "";
    let vlanIteracion = "";
    let cantidadIpsSinNombre = 0;
    resultado.forEach(element => {
      if (element.direccionIp.vlan.nombreVlan != vlanIteracion) {
        //se escribe los datos iniciales de la vlan que se va a establecer 
        resultadoUnion += "\n";
        resultadoUnion += "SE ASIGNÓ LA " + element.direccionIp.vlan.nombreVlan + "\n"
        resultadoUnion += "\n";

        resultadoUnion += "Las IP asignadas son las siguientes : " + "\n";
        vlanIteracion = element.direccionIp.vlan.nombreVlan;
      }
      if (element.direccionIp.nombreDispositivo != null) {
        resultadoUnion += element.direccionIp.nombreDispositivo + " - " + element.direccionIp.direccion + "\n";
      } else {
        cantidadIpsSinNombre++;
      }
    });
    // Agregar el valor de las IPs sin nombre creadas
    if (cantidadIpsSinNombre != 0) {
      resultadoUnion += "Se asignaron " + cantidadIpsSinNombre + " IP sin nombre\n";
    }
    return resultadoUnion;
  }

  asignarDispositivosVlan() {
    this.vlanAsignacion = new Vlan()
    this.vlanAsignacion = this.vlans.filter((vlanSeleccionadaAsignacion: Vlan) => vlanSeleccionadaAsignacion.idVlan == this.idVlanSeleccionado)[0];

    let vlanValidacion: Vlan = this.vlansParaAgregar.filter(x => x.idVlan == this.vlanAsignacion.idVlan)[0];
    if (vlanValidacion === undefined) {

      this.vlanAsignacion.asignaciones = new Array<AsignacionDispositivoDto>();
      if (this.listaDispositivosAsignar.length > 0) {
        this.vlanAsignacion.asignaciones = this.listaDispositivosAsignar.map(obj => ({ ...obj }));
      } else {
        let asignacionMarca: AsignacionDispositivoDto = new AsignacionDispositivoDto();
        asignacionMarca.nombre = "Configuracion automatica"
        this.vlanAsignacion.asignaciones.push(asignacionMarca)
      }

      this.vlansParaAgregar.push(this.vlanAsignacion);
      swal("Se agrego la vlan correctamente", "", "success")
    } else {
      swal("Se presento un error", "La Vlan ya existe en la lista por favor eliminelo para agregarlo nuevamente", "error")
    }

  }
  arrayAString(elementosDispositivo: AsignacionDispositivoDto[]) {
    let resultado: string = "";
    elementosDispositivo.forEach(element => {
      resultado += element.nombre + "\n"
    });
    return resultado;
  }
}



// WEBPACK FOOTER //
// ./src/app/solicitar-dir-vlan/solicitar-dir-vlan.component.ts